import React from 'react';

const CloseModalIcon: React.FC = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.47121 22.2534L22.2509 8.46875M8.46875 8.47121L22.2534 22.2509" stroke="black" />
    </svg>
  );
};

export default CloseModalIcon;
